// Not-found feature – route kontrakt

import type { SliceRouteContract } from '@/shared/lib/vsa';
import { NotFoundPage } from './NotFoundPage';

export const notFoundRouteContract: SliceRouteContract = {
  routeId: 'not-found',
  component: NotFoundPage,
};
